module.exports = __webpack_public_path__ + "img/service-02.79e324df.png";